export const RECOMMEND_WORLDS_LIMIT = 12
export const RECOMMEND_VIEW_ALL_THRESHOLD = 5

export const LOGO_OVERLAY_RECOMMENDATIONS_LIMIT = 15
export const CONTROL_BAR_RECOMMENDATIONS_LIMIT = 50
export const OWNER_RECOMMEND_WORLDS_PAGE_SIZE = 12
/** Cookie name the visitor id is read from (client and server). */
export const RECOMMEND_VISITOR_ID_COOKIE_KEY = 'csdataBid'
/** Request body field name the visitor id is sent as to `/recommendation/worlds`. */
export const RECOMMEND_VISITOR_ID_BODY_KEY = 'csdata_bid'

export type RecommType =
  | 'regional'
  | 'personalized'
  | 'personalized-v2'
  | 'personalized-v3'
  | 'content-based'
  | 'content-based-b'
  | 'regional-b'
  | 'also-viewed'
  | 'hybrid'
  | 'hybrid-video'
  | 'hybrid-game'
  | 'hybrid-experience'
  | 'popular-video'
  | 'popular-game'
  | 'popular-experience'

export type RecommendVariant = RecommType | 'control' | (string & {})

export const RECOMMEND_VARIANT = {
  CONTROL: 'control',
  HYBRID_GAME: 'hybrid-game',
  HYBRID_EXPERIENCE: 'hybrid-experience',
} as const
